/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { SYSTEM_OVERVIEW_ANOMALY_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

/* Import libraries */
import { logDebug } from '@/lib/app/debugLog';

interface SystemsTabProps {
    showSystemSortGroups?: boolean;
}

function SystemsTab({ showSystemSortGroups = true }: SystemsTabProps) {
    logDebug('info', {
        type: 'SÜ BK',
        source: 'src/components/tabs/overview/navigation/SystemsTab.tsx',
        function: 'SystemsTab',
        message: 'Übergibt SYSTEM_OVERVIEW_ANOMALY_CONFIGS aus overviewAnomalyConfig.',
        content: SYSTEM_OVERVIEW_ANOMALY_CONFIGS,
    });

    return (
        <AnomalyMetricsOverview
            anomalyConfigs={SYSTEM_OVERVIEW_ANOMALY_CONFIGS}
            description="Overview of all available systems."
            gridClassName="lg:grid-cols-3 2xl:grid-cols-4"
            groupBy="system"
            heading="Systems"
            idPrefix="systems"
            showSystemSortGroups={showSystemSortGroups}
        />
    );
}

export default SystemsTab;
